import React from 'react';
import ProductTopSection from '../../../../components/Sangjo-Ujieon/ProductTopSection';
import ProductSubHeading from '../../../../components/Sangjo-Ujieon/ProductSubHeading';
import ProductTabMobile from '../../../../components/Sangjo-Ujieon/ProductTabMobile';

const ProductInfoMobile = () => {
  return (
    <div className="announcement-list-page product-info-page">
      <ProductTopSection />

      {/* Main Content */}
      <main className="main-content">
        <ProductSubHeading heading="상품안내" />

        {/* Product Information Section */}
        <section className="product-info-mobile-section sky-hall-special-room-mobile-pricing-section">

          <ProductTabMobile selectedHall="상품안내" />

          <div className="mutual-assistance-product-info-main-content">
            <div className="mutual-assistance-product-info-page-content mutual-assistance-product-info-container">
              <div className="mutual-assistance-product-info-pricing-table-container">
                <table className="mutual-assistance-product-info-pricing-table">
                  <thead>
                    <tr>
                      <th colSpan="2">항목</th>
                      <th>파라다이스290</th>
                      <th colSpan="4">파라다이스390</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colSpan="2">장례지도사</td>
                      <td>1명 (3일 진행)</td>
                      <td colSpan="4">1명 (3일 진행)</td>
                    </tr>
                    <tr>
                      <td colSpan="2">염습/입관 지원</td>
                      <td>1명 (2일차)</td>
                      <td colSpan="4">1명 (2일차)</td>
                    </tr>
                    <tr>
                      <td colSpan="2">접객도우미</td>
                      <td>4명 (1일 10시간)</td>
                      <td colSpan="4">5명 (1일 10시간)</td>
                    </tr>
                    <tr>
                      <td rowSpan="3">관</td>
                      <td className='grey-bg'>매장</td>
                      <td>오동 1.5치 (약4.5cm)</td>
                      <td colSpan="4">오동 1.5치 (약4.5cm)</td>
                    </tr>
                    <tr>
                      <td className='grey-bg'>화장</td>
                      <td>화장용 관 + 기본 유골함</td>
                      <td colSpan="4">화장용 관+2중 유골함</td>
                    </tr>
                    <tr>
                      <td className='grey-bg'>탈관</td>
                      <td>오동1치 + 오동횡대</td>
                      <td colSpan="4">오동1치 + 오동횡대</td>
                    </tr>
                    <tr>
                      <td colSpan="2">수의</td>
                      <td>대마수의(대마 100%, 기계직)</td>
                      <td colSpan="4">고급대마수의(대마 100%, 기계직)</td>
                    </tr>
                    <tr>
                      <td colSpan="2">전통 상주용품</td>
                      <td>각 4벌 (굴건제복/두루마기/중단/두건/행전/수질/요질/작지/복조끼/치마/저고리 등)</td>
                      <td colSpan="4">각 7벌 (굴건제복/두루마기/중단/두건/행전/수질/요질/작지/복조끼/치마/저고리 등)</td>
                    </tr>
                    <tr>
                      <td colSpan="2">현대 상주용품</td>
                      <td>각 4세트 (남자상복 (상하의, 셔츠, 타이 포함)/여자상복 대여)</td>
                      <td colSpan="4">각 7세트 (남자상복 (상하의, 셔츠, 타이 포함)/여자상복 대여)</td>
                    </tr>
                    <tr>
                      <td colSpan="2">헌화</td>
                      <td>30송이</td>
                      <td colSpan="4">50송이</td>
                    </tr>
                    <tr>
                      <td colSpan="2">생화제단장식</td>
                      <td>현금 20만원 지원</td>
                      <td colSpan="4">현금 30만원 지원</td>
                    </tr>
                    <tr>
                      <td colSpan="2">생화바구니</td>
                      <td>2개</td>
                      <td colSpan="4">2개</td>
                    </tr>
                    <tr>
                      <td colSpan="2">메모리얼 코너 또는 근조화환</td>
                      <td>-</td>
                      <td colSpan="4">제공</td>
                    </tr>
                    <tr>
                      <td colSpan="2">기타용품</td>
                      <td>규격품(초/향/부의록/근조기/영정리본/축문/위패 등)</td>
                      <td colSpan="4">규격품(초/향/부의록/근조기/영정리본/축문/위패 등)</td>
                    </tr>
                    <tr>
                      <td colSpan="2">향로/촛대/잔대</td>
                      <td>제공</td>
                      <td colSpan="4">제공</td>
                    </tr>
                    <tr>
                      <td colSpan="2">입관 수시용품</td>
                      <td>규격품 (수시보/고깔/관보/베개/습신/보공/한지/결관바/알코올/탈지면/에단/공포/운아/기도문 등 50여 가지)</td>
                      <td colSpan="4">규격품 (수시보/고깔/관보/베개/습신/보공/한지/결관바/알코올/탈지면/에단/공포/운아/기도문 등 50여 가지)</td>
                    </tr>
                    <tr>
                      <td rowSpan="3">장의 차량</td>
                      <td className='grey-bg'>앰뷸런스</td>
                      <td>관내무료</td>
                      <td colSpan="4">관내무료</td>
                    </tr>
                    <tr>
                      <td className='grey-bg'>고인 전용 리무진</td>
                      <td rowSpan="2">택1 (왕복 200Km)</td>
                      <td rowSpan="2" colSpan="4">택1 (왕복 300Km)</td>
                    </tr>
                    <tr>
                      <td className='grey-bg'>유족버스</td>
                    </tr>
                    <tr>
                      <td colSpan="2">행정지원</td>
                      <td colSpan="2" className='text-left'>화장장예약, 사망진단서 발급안내, 화장접수, 장례사후 안내, 석물, 장지 음식, 산역 등 안내</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan="2">행사금액</td>
                      <td className='text-left price-text'>290만원</td>
                      <td className='text-left price-text'>390만원</td>
                    </tr>
                  </tfoot>
                </table>
              </div>

              {/* Notes Section */}
              <div className="mutual-assistance-product-info-notes-section">
                <h3 className="mutual-assistance-product-info-notes-title">유의사항</h3>
                <div className="mutual-assistance-product-info-notes-separator"></div>
                <ul className="mutual-assistance-product-info-notes-list">
                  <li>장례식장 시설 이용료, 염습비, 식사 및 제사비, 화장비, 묘지 관련 비용 등은 포함되지 않습니다.</li>
                  <li>화장 시 고인 전용 리무진은 화장장까지만 제공됩니다.</li>
                  <li>유족버스 및 리무진은 기본 제공 거리 초과 시 10km마다 2만원이 추가 요금됩니다 (통행료 별도).</li>
                  <li>서비스 내용은 지역에 따라 고객 동의 하에 변경될 수 있습니다.</li>
                  <li>고인 운반 서비스(앰뷸런스)는 당사 요청 시 이용 가능합니다 (관내 무료).</li>
                  <li>위 서비스는 후불 서비스이며, 행사 기간에 따라 금액이 변동될 수 있습니다.</li>
                </ul>
              </div>
            </div>
          </div>

        </section>

      </main>
    </div>
  );
};

export default ProductInfoMobile; 